var _path, _linearGradient, _linearGradient2, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArduino(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2499,
    height: 2500,
    viewBox: "0 0 1372.201 1372.684",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00979D",
    stroke: "#81C9CB",
    strokeWidth: 0.932,
    strokeMiterlimit: 10,
    d: "M1371.701 686.024c0 378.658-306.972 685.605-685.549 685.605C307.451 1371.629.5 1064.682.5 686.024.5 307.455 307.451.483 686.152.483c378.594.001 685.549 306.972 685.549 685.541z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: -16.3,
    y1: 16.071,
    x2: 1354.901,
    y2: 16.071,
    gradientTransform: "matrix(1 0 0 -1 16.8 702.696)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#c0d1d3",
    stopOpacity: 0.153
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#91b3b7",
    stopOpacity: 0.306
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#6d9fa3",
    stopOpacity: 0.457
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#4d9195",
    stopOpacity: 0.604
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    stopColor: "#30888b",
    stopOpacity: 0.746
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#148386",
    stopOpacity: 0.881
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008184"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: -16.8,
    y1: 16.071,
    x2: 1355.401,
    y2: 16.071,
    gradientTransform: "matrix(1 0 0 -1 16.8 702.696)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153,
    stopColor: "#c0d1d3",
    stopOpacity: 0.153
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#91b3b7",
    stopOpacity: 0.306
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457,
    stopColor: "#6d9fa3",
    stopOpacity: 0.457
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604,
    stopColor: "#4d9195",
    stopOpacity: 0.604
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#30888b",
    stopOpacity: 0.746
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "#148386",
    stopOpacity: 0.881
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008184"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "url(#a)",
    stroke: "url(#b)",
    strokeMiterlimit: 10,
    d: "M1371.701 686.595c0 378.65-306.972 685.606-685.549 685.606C307.451 1372.201.5 1065.23.5 686.595.5 308.019 307.451 1.048 686.152 1.048c378.594.016 685.549 306.97 685.549 685.547z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M947.959 931.196c-12.909 0-26.127-.929-39.127-2.864-108.978-15.554-181.848-93.822-222.665-153.989-40.946 60.166-113.811 138.512-222.74 154.045a275.864 275.864 0 0 1-39.133 2.785c-67.753 0-131.358-25.217-179.201-71.003-48.299-46.165-74.951-108.114-74.951-174.171 0-66.14 26.651-128.004 75.021-174.253 47.797-45.793 111.449-70.936 179.231-70.936 12.918 0 26.067.928 39.023 2.783 108.932 15.535 181.794 93.813 222.743 153.99 40.825-60.177 113.689-138.432 222.658-153.99 13-1.863 26.148-2.783 39.066-2.783 67.753 0 131.401 25.208 179.197 70.936 48.345 46.249 74.937 108.113 74.937 174.253 0 66.057-26.524 128.006-74.868 174.171-47.881 45.785-111.434 71.026-179.191 71.026M734.42 686.024c21.283 40.534 84.067 141.676 186.692 156.375 8.984 1.236 18.028 1.923 26.839 1.923 92.185 0 167.225-71.002 167.225-158.322s-75.023-158.321-167.291-158.321c-8.812 0-17.853.629-26.753 1.921-102.644 14.664-165.428 115.806-186.712 156.424M424.393 527.702c-92.308 0-167.36 70.998-167.36 158.321 0 87.305 75.021 158.322 167.245 158.322 8.852 0 17.897-.688 26.879-1.922 102.629-14.697 165.394-115.783 186.689-156.375-21.237-40.535-84.061-141.761-186.689-156.376-8.877-1.341-17.945-1.97-26.764-1.97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.37 662.051h152.625v49.181H354.37zM1016.484 662.051h-51.671v-51.747h-49.348v51.747h-51.648v49.181h51.648v51.737h49.348v-51.737h51.671z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArduino);
export default __webpack_public_path__ + "static/media/arduino.a5e89835a9daf96b985621e1b4c78b3a.svg";
export { ForwardRef as ReactComponent };